import React, { createContext, useEffect, useState } from 'react';
import { Api } from '@sodamnfoolish/sjc-backend-types';
import { usePumpGateway } from '../../../Hooks/usePumpGateway';

export const LiveDataPumpTokensContext = createContext<LiveDataPumpTokens | null>(null);

export function LiveDataPumpTokensProvider({ children }: React.PropsWithChildren<{}>) {
    const { pumpGatewayClient } = usePumpGateway();

    const [pumpFunTokens, setPumpFunTokens] = useState<LiveDataPumpTokens | null>(null);

    useEffect(() => {
        if (!pumpGatewayClient) return;

        pumpGatewayClient.on(Api.Pump.Gateway.Event.TokenTrade, async (event: Api.Pump.DTO.PumpFunToken) => {
            setPumpFunTokens((prevTokens) => ({
                ...prevTokens,
                [event.mint]: event,
            }));
        });

        return () => {
            pumpGatewayClient.off(Api.Pump.Gateway.Event.TokenTrade);
        };
    }, [pumpGatewayClient]);

    return <LiveDataPumpTokensContext.Provider value={pumpFunTokens}>{children}</LiveDataPumpTokensContext.Provider>;
}

type LiveDataPumpTokens = Record<string, Api.Pump.DTO.PumpFunToken>;
